import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Form, Input, Button, Typography, Checkbox, notification } from "antd";
import { MailOutlined, LockOutlined, CloseCircleOutlined, } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import { authService } from "../services";
import { ROLES } from "../constants";
import { fetchPermissions } from "../redux/slices/permissionsSlice";
import { useDispatch } from "react-redux";
import { createEcho } from "../echo";
const { Title } = Typography;

const LoginForm = ({ onLogin }) => {

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  let location = useLocation();
  const navigate = useNavigate();
  let role;

  const onFinish = async (values) => {
    setLoading(true);
    const response = await authService.loginPost(
      values.email,
      values.password,
      values.remember
    );

    console.log("Login response:", response); // Log the response for debugging

    const { success, data } = response;
    if (success ?? false) {
      onLogin();
      if (data.user.id !== 1 && data.user.is_agreement_required === 1 && data.user.isDriver !== 1 && data.user.isContractSign === 0 && data.user.employee_id === 0) {
        navigate(`/term-&-condition`)
        // navigate(`/term-&-condition`)
        role = (data.user.user_level === 10) & (data.user.employee_id === 0) ? ROLES.ADMIN : (data.user.user_level === 1) & (data.user.employee_id === 0) ? ROLES.CUSTOMER : ROLES.EMPLOYEE;
        localStorage.setItem("isAllowed", false)
      }
      else if (data.user.isDriver === 1) {
        role = ROLES.DRIVER
        // navigate("/operations/appointment/add")
        navigate("/")
        localStorage.setItem("isAllowed", true)
      }
      else {
        navigate("/");
        role = (data.user.user_level === 10) & (data.user.employee_id === 0) ? ROLES.ADMIN : (data.user.user_level === 1) & (data.user.employee_id === 0) ? ROLES.CUSTOMER : ROLES.EMPLOYEE;
        localStorage.setItem("isAllowed", true)
      }
      localStorage.setItem("token", data.token);

      if (Array.isArray(data.ticker_messages)) {
        localStorage.setItem(
          "ticker",
          JSON.stringify(data.ticker_messages)
        );
      } else {
        localStorage.setItem("ticker", JSON.stringify([]));
      }

      window.Echo = createEcho(data.token);
      localStorage.setItem("role", role);
      localStorage.setItem("name", data.user.name);
      localStorage.setItem("user", JSON.stringify(data.user))
      dispatch(fetchPermissions(role));
    } else {
      notification.open({ message: response.message, icon: <CloseCircleOutlined style={{ color: "red" }} /> });
    }
    setLoading(false);
  };

  const onFinishFailed = (errorInfo) => {
    console.error("Failed:", errorInfo);
  };

  return (
    <div className="login-container  ">
      <div style={{ marginBottom: 15, display: "flex", flexDirection: "column" }}>
        {/* <img
          src={COMPANY_LOGO}
          alt="ctrade-Logo"
          style={{ width: "350px", height: "95px", marginBottom: 10, marginLeft: "0px", }}
        /> */}
        <Title id="title" style={{ fontSize: "20px" }}>
          Sign in
        </Title>
        <p>Enter your details to continue</p>
      </div>

      <Form
        layout="vertical"
        style={{ width: "370px" }}
        name="basic"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={{ email: location.state?.email || null }}
      >
        <Form.Item
          className="login-form-item mb-4"
          name="email"
          label='Email'
          rules={[
            { type: "email", message: "The input is not valid email!" },
            { required: true, message: "Please input your email!" },
          ]}
        >
          <Input
            prefix={<MailOutlined style={{ paddingRight: "10px", paddingLeft: "2px" }} />}
            type="email"
            style={{ borderRadius: "12px", height: "40px" }}
            placeholder="Enter your email"
            allowClear
          />
        </Form.Item>

        <Form.Item
          className="login-form-item"
          name="password"
          label="Password"
          rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Input.Password
            prefix={<LockOutlined style={{ paddingRight: "10px", paddingLeft: "2px" }} />}
            style={{ borderRadius: "12px", height: "40px" }}
            placeholder="Enter your password"
            allowClear
          />
        </Form.Item>
        <div className="flex justify-between items-center mb-2">

          <Form.Item name="remember" valuePropName="checked" initialValue={true} style={{ margin: 0, padding: 0 }}>
            <Checkbox > Remember Me</Checkbox>

            {/* <p style={{ fontSize: "12px", overflow: "hidden" }}>
            By signing in, you agree to Ctrade’s{" "}
            <a className="underline">User Agreement</a> and{" "}
            <a className="underline">Privacy Policy</a>
          </p> */}
          </Form.Item>

          <Link to="/forgot-password" className="text-primary hover:underline hover:text-primary">
            Forgot Password?
          </Link>
        </div>

        <Form.Item className="login-form-item" style={{ marginTop: 15 }}>
          <Button
            style={{
              width: "370px",
              borderRadius: "12px",
              height: "40px",
            }}
            type="primary"
            htmlType="submit"
            loading={loading}
          >
            LOGIN
          </Button>
        </Form.Item>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "4px"
          }}
          className="mt-4"
        >
          <span>New here?</span><Link to={"/SignUp"} className=" hover:underline font-bold hover:text-primary">
            Create An Account
          </Link>


        </div>
      </Form>
      {/* ForgetPassword Modal */}
    </div>
  );
};
export default LoginForm;
